import { StateEffect, StateField } from "@codemirror/state";

export const toggleVisualEffect = StateEffect.define();

export const visualState = StateField.define({
    create() {
        return false;
    },
    update(value, transaction) {
        for (const effect of transaction.effects) {
            if (effect.is(toggleVisualEffect)) {
                return effect.value;
            }
        }
        return value;
    },
});

export function isVisual(view) {
    return view.state.field(visualState, false) || false;
}
